import { cssRule } from 'typestyle';

cssRule('.tb-col-drag-target', {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    bottom: 0,
    left: '-3px',
    right: '-3px',
    backgroundColor: 'transparent',
    cursor: 'col-resize',
});

cssRule('.tb-row-drag-target', {
    position: 'absolute',
    zIndex: 1,
    top: '-3px',
    bottom: '-3px',
    left: 0,
    right: 0,
    backgroundColor: 'transparent',
    cursor: 'row-resize',
});

